import type { TFunction } from 'i18next';

export const getGoodsLabels = (
  translate: TFunction
): {
  [key: string]: {
    heading: string;
    small: string;
  };
} => ({
  doorsFields: {
    heading: translate('calculator.dimensions.doorsWindows.goodsLabels.doors'),
    small: translate('calculator.dimensions.doorsWindows.goodsLabels.door'),
  },
  windowsFields: {
    heading: translate('calculator.dimensions.doorsWindows.goodsLabels.windows'),
    small: translate('calculator.dimensions.doorsWindows.goodsLabels.window'),
  },
});
